import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function FiltersSeparator({ sx }) {
    return jsx(Line, { sx: sx });
}
const Line = styled("div")(({ theme }) => ({
    height: 1,
    backgroundColor: theme.palette.ui50,
}));

export { FiltersSeparator, Line };
//# sourceMappingURL=FiltersSeparator.js.map
